var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.759 3.96v.34a8.606 8.606 0 0 0-5.891 8.168v5.236a.124.124 0 0 1-.122.124 2.497 2.497 0 0 0-2.496 2.495v1.31c0 .656.531 1.186 1.187 1.186h6.231v.123a3.805 3.805 0 0 0 7.609 0v-.123h6.23c.657 0 1.188-.534 1.188-1.186v-1.31a2.498 2.498 0 0 0-2.496-2.495.12.12 0 0 1-.122-.124v-5.236a8.607 8.607 0 0 0-5.891-8.167V3.96a2.712 2.712 0 0 0-2.713-2.714A2.715 2.715 0 0 0 9.758 3.96z",
    stroke: "#827C78",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify_icon.ad6849ba80e6127d13bd4a37edc8d578.svg";
export { ForwardRef as ReactComponent };